import React from 'react'

const ManagementTasksMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_1037_33439)"
      fillOpacity="0.1"
    />
    <path
      d="M19.1563 23.5001C17.7196 23.5001 16.2828 23.5001 14.8461 23.5001C14.3073 23.5001 13.8284 23.1409 13.7086 22.662C13.529 21.9436 14.0678 21.2551 14.7862 21.2551C16.0733 21.2551 17.3604 21.2551 18.6475 21.2551C20.2638 21.2551 21.9101 21.2551 23.5265 21.2551C24.0353 21.2551 24.5142 21.6442 24.604 22.1232C24.7238 22.632 24.4843 23.1708 24.0054 23.3803C23.8258 23.4701 23.6163 23.5001 23.4367 23.5001C22.0598 23.5001 20.5931 23.5001 19.1563 23.5001Z"
      fill="#052351"
    />
    <path
      d="M19.1864 12.3652C17.7496 12.3652 16.3129 12.3652 14.8761 12.3652C14.2176 12.3652 13.7087 11.8863 13.7087 11.2278C13.7087 10.5992 14.2176 10.0903 14.8761 10.0903C17.7496 10.0903 20.6531 10.0903 23.5266 10.0903C24.1552 10.0903 24.6041 10.5094 24.6939 11.108C24.7538 11.6767 24.3946 12.1856 23.796 12.3353C23.7062 12.3652 23.6164 12.3652 23.5266 12.3652C22.0599 12.3652 20.6231 12.3652 19.1864 12.3652Z"
      fill="#052351"
    />
    <path
      d="M19.1864 15.5379C20.653 15.5379 22.0898 15.5379 23.5565 15.5379C24.0953 15.5379 24.5742 15.9569 24.664 16.4658C24.7538 17.0345 24.4545 17.5733 23.8857 17.7229C23.766 17.7828 23.6463 17.7828 23.5266 17.7828C20.6231 17.7828 17.7197 17.7828 14.8162 17.7828C14.2176 17.7828 13.7387 17.3338 13.6788 16.7352C13.6189 16.1664 14.008 15.6576 14.6067 15.5379C14.6965 15.5079 14.7863 15.5079 14.8761 15.5079C16.3128 15.5379 17.7496 15.5379 19.1864 15.5379Z"
      fill="#052351"
    />
    <path
      d="M9.30864 10.5393C9.7277 10.1202 10.0869 9.70116 10.476 9.31204C10.6556 9.13244 10.8053 8.95285 10.9849 8.77326C11.344 8.41407 11.8529 8.41407 12.2121 8.74332C12.5713 9.07258 12.5713 9.61136 12.242 9.97055C11.5536 10.7189 10.8651 11.4372 10.1767 12.1556C9.57803 12.7842 8.68006 12.6944 8.17121 11.976C7.93175 11.6168 7.69229 11.2576 7.45283 10.8985C7.18344 10.4495 7.27324 9.94062 7.69229 9.67123C8.08141 9.40184 8.6202 9.52157 8.91952 9.94062C9.03925 10.1202 9.15898 10.3297 9.30864 10.5393Z"
      fill="#052351"
    />
    <path
      d="M9.42845 17.8129C10.0566 17.8129 10.5659 17.3037 10.5659 16.6755C10.5659 16.0473 10.0566 15.5381 9.42845 15.5381C8.80026 15.5381 8.29102 16.0473 8.29102 16.6755C8.29102 17.3037 8.80026 17.8129 9.42845 17.8129Z"
      fill="#052351"
    />
    <path
      d="M9.42845 23.4997C10.0566 23.4997 10.5659 22.9905 10.5659 22.3623C10.5659 21.7341 10.0566 21.2249 9.42845 21.2249C8.80026 21.2249 8.29102 21.7341 8.29102 22.3623C8.29102 22.9905 8.80026 23.4997 9.42845 23.4997Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1037_33439"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default ManagementTasksMenu
